function searchFormExtras() {


    if (document.querySelector(".budget-modal")) {

        let budgetModal = document.querySelector(".budget-modal");
        let minPriceValue = document.querySelector(".minPriceValue");
        let maxPriceValue = document.querySelector(".maxPriceValue");


        let originalText = document.querySelector(".originalText");
        let minPriceLabel = document.querySelector(".minPriceLabel");
        let maxPriceLabel = document.querySelector(".maxPriceLabel");
        let minPriceText = document.querySelector(".minPriceText");
        let maxPriceText = document.querySelector(".maxPriceText");

        function priceTextChange(min_price = false, max_price = false) {

            originalText.classList.add("d-none");

            if (min_price) {
                minPriceText.innerText = min_price + '€';

                minPriceLabel.classList.remove("d-none");
                // maxPriceLabel.classList.add("d-none");
                // originalText.classList.remove("d-none");
            }

            if (max_price) {
                maxPriceText.innerText = max_price + '€';

                // minPriceLabel.classList.add("d-none");
                maxPriceLabel.classList.remove("d-none");
                // originalText.classList.remove("d-none");
            }

            if (min_price && max_price) {
                minPriceText.innerText = min_price + '€';
                maxPriceText.innerText = max_price + '€';

                minPriceLabel.classList.remove("d-none");
                maxPriceLabel.classList.remove("d-none");
            }

            // if (!min_price && !max_price) {
            //     minPriceLabel.classList.add("d-none");
            //     maxPriceLabel.classList.add("d-none");
            //     originalText.classList.remove("d-none");
            // }

        }


        budgetModal.querySelectorAll('input[type="radio"]').forEach( (e) => {
            e.addEventListener('change', () => {
                
                if(e.classList.contains('radio-min-price')){
                    minPriceValue.value = e.value;
                    priceTextChange(e.dataset.formattedPrice, false);
                }
                if(e.classList.contains('radio-max-price')){
                    maxPriceValue.value = e.value;
                    priceTextChange(false, e.dataset.formattedPrice);
                }
    

            });
        });
       
        budgetModal.querySelectorAll('input[type="radio"][checked]').forEach( (e) => {
            if(e.classList.contains('radio-min-price')){
                minPriceValue.value = e.value;
                priceTextChange(e.dataset.formattedPrice, false);
            }
            if(e.classList.contains('radio-max-price')){
                maxPriceValue.value = e.value;
                priceTextChange(false, e.dataset.formattedPrice);
            }
        });

    }

}

document.addEventListener('DOMContentLoaded', () => {
    searchFormExtras();
})



